var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTesla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E82127"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2704_38919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0009 24.0529L18.3511 10.8351C20.5913 10.8351 21.2979 11.0808 21.4 12.0834C21.4 12.0834 22.9027 11.5231 23.6607 10.3851C20.703 9.01453 17.7311 8.95272 17.7311 8.95272L15.997 11.0649L16.0009 11.0646L14.2668 8.95239C14.2668 8.95239 11.2949 9.01427 8.33759 10.3848C9.09487 11.5228 10.5982 12.0832 10.5982 12.0832C10.7009 11.0804 11.4066 10.8348 13.6318 10.8332L16.0009 24.0529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34274C18.3909 8.32445 21.1275 8.7126 23.9291 9.93362C24.3035 9.25968 24.3997 8.96183 24.3997 8.96183C21.3373 7.75021 18.4693 7.33557 15.9997 7.32516C13.5301 7.33557 10.6623 7.75028 7.60024 8.96183C7.60024 8.96183 7.73685 9.32871 8.07061 9.93362C10.8716 8.7126 13.6087 8.32445 15.9997 8.34274H16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2704_38919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4615,
    height: 17.5385,
    fill: "white",
    transform: "translate(6.76923 7.23077)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTesla);
export default __webpack_public_path__ + "static/media/LogoTesla.0e7664d7094b8d914def07520c2d5493.svg";
export { ForwardRef as ReactComponent };